import { CreatePersonalFoodComponent } from './presentation/plan/personal-package/create-personal-food/create-personal-food.component';
import { AddPersonalPackageComponent } from './presentation/plan/personal-package/add-personal-package/add-personal-package.component';
import { AddPersonalComponent } from './presentation/plan/personal-package/add-personal/add-personal.component';
import { MainPersonalComponent } from './presentation/plan/personal-package/main-personal/main-personal.component';
import { BlogSettingComponent } from './presentation/blog/blog-setting/blog-setting.component';
import { BlogCreatPostComponent } from './presentation/blog/blog-creat-post/blog-creat-post.component';
import { BlogSuggestComponent } from './presentation/blog/blog-suggest/blog-suggest.component';
import { BlogWithTagComponent } from './presentation/blog/blog-with-tag/blog-with-tag.component';
import { BlogActivityComponent } from './presentation/blog/blog-activity/blog-activity.component';
import { BlogSearchComponent } from './presentation/blog/blog-search/blog-search.component';
import { PostDetailComponent } from './presentation/blog/post-detail/post-detail.component';
import { FollowerFollowingComponent } from './presentation/blog/follower-following/follower-following.component';
import { BlogProfileComponent } from './presentation/blog/blog-profile/blog-profile.component';
import { ExercisesComponent } from './presentation/plan/log-exercise/exercises/exercises.component';
import { TermsofuseComponent } from './presentation/authentication/termsofuse/termsofuse.component';
import { MessageInboxComponent } from './presentation/setting/message-inbox/message-inbox.component';
import { AnswerPageComponent } from './presentation/setting/answer-page/answer-page.component';
import { DietTypeOverviewComponent } from './presentation/plans/diet-type-overview/diet-type-overview.component';
import { DeeplinkComponent } from './presentation/main/deeplink/deeplink.component';
import { PromotionComponent } from './presentation/register/register/promotion/promotion.component';
import { PlanOverviewComponent } from './presentation/plan/plan-overview/plan-overview.component';
import { BookmarkedRecipesComponent } from './presentation/recipe/bookmarked-recipes/bookmarked-recipes.component';
import { RecipeDetailComponent } from './presentation/recipe/recipe-detail/recipe-detail.component';
import { RecipeCategoryComponent } from './presentation/recipe/recipe-category/recipe-category.component';
import { SupportPageComponent } from './presentation/setting/support-page/support-page.component';
import { ReferralComponent } from './presentation/profile/referral/referral.component';
import { DietPersonalTypeComponent } from './presentation/generate/diet-personal-type/diet-personal-type.component';
import { TribuneSettingComponent } from './presentation/setting/tribune-setting/tribune-setting.component';
import { PersonalInfoComponent } from './presentation/setting/personal-info/personal-info.component';
import { ReportProblemComponent } from './presentation/setting/report-problem/report-problem.component';
import { FaqComponent } from './presentation/setting/faq/faq.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PhoneRegisterComponent } from './presentation/authentication/phone-register/phone-register.component';
import { ActivationCodeComponent } from './presentation/authentication/activation-code/activation-code.component';
import { RegisterComponent } from './presentation/register/register/register.component';
import { DietTypeComponent } from './presentation/generate/diet-type/diet-type.component';
import { GenerateComponent } from './presentation/generate/generate/generate.component';
import { GenerateOverviewComponent } from './presentation/generate/generate-overview/generate-overview.component';
import { MainComponent } from './presentation/main/main.component';
import { CheatDayComponent } from './presentation/plan/cheat-day/cheat-day.component';
import { MealDetailComponent } from './presentation/plan/meal-detail/meal-detail.component';
import { ChangeMealComponent } from './presentation/plan/change-meal/change-meal.component';
import { DietDetailComponent } from './presentation/profile/diet-detail/diet-detail.component';
import { ProfileWaterChartComponent } from './presentation/profile/profile-water-chart/profile-water-chart.component';
import { ProfileWeightChartComponent } from './presentation/profile/profile-weight-chart/profile-weight-chart.component';
import { SettingComponent } from './presentation/setting/setting.component';
import { AboutUsComponent } from './presentation/setting/about-us/about-us.component';
import { ShopComponent } from './presentation/shop/shop.component';
import { AuthGuard } from './utils/authGuard';
import { AddFoodComponent } from './presentation/plan/add-food/add-food.component';
import { IntroComponent } from './presentation/intro/intro.component';
import { DailyFoodFactComponent } from './presentation/plan/daily-food-fact/daily-food-fact.component';
import { MessagePageComponent } from './presentation/setting/message-page/message-page.component';
import { ExerciseMainComponent } from './presentation/plan/log-exercise/exercise-main/exercise-main.component';
import { CreatePersonalPackageComponent } from './presentation/plan/personal-package/create-personal-package/create-personal-package.component';
import { CookingStorySearchComponent } from './presentation/cooking-story/cooking-story-search/cooking-story-search.component';
import { CookingStoryRecipePageComponent } from './presentation/cooking-story/cooking-story-recipe-page/cooking-story-recipe-page.component';
import { CookingStoryTutorialComponent } from './presentation/cooking-story/cooking-story-tutorial/cooking-story-tutorial.component';
import { CookingStoryShowMoreComponent } from './presentation/cooking-story/cooking-story-show-more/cooking-story-show-more.component';
import { CookingStoryFavoriteComponent } from './presentation/cooking-story/cooking-story-favorite/cooking-story-favorite.component';
import { CookingStoryComponent } from './presentation/cooking-story/cooking-story.component';
import { CookingStoryHomeComponent } from './presentation/cooking-story/cooking-story-home/cooking-story-home.component';
import { CookingStoryKitchenComponent } from './presentation/cooking-story/cooking-story-kitchen/cooking-story-kitchen.component';
import { ShoppinglistSearchComponent } from './presentation/cooking-story/cooking-story-kitchen/shoppinglist/shoppinglist-search/shoppinglist-search.component';
import { KitchenSearchComponent } from './presentation/cooking-story/cooking-story-kitchen/kitchen/kitchen-search/kitchen-search.component';
import { CookingStoryMembersComponent } from './presentation/cooking-story/cooking-story-members/cooking-story-members.component';

const appTitle = 'بنتو';
const routes: Routes = [
  {
    path: 'intro',
    component: IntroComponent,
    data: { title: appTitle, animation: 'Intro' },
  },
  {
    path: 'authentication1',
    component: PhoneRegisterComponent,
    data: { title: appTitle, animation: 'Authentication1' },
  },
  {
    path: 'termsofuse',
    component: TermsofuseComponent,
    data: { title: appTitle, animation: 'TermofUse' },
  },
  {
    path: 'authentication1/:phoneNumber',
    component: PhoneRegisterComponent,
    data: { title: appTitle, animation: 'Authentication1' },
  },
  {
    path: 'authentication2/:phoneNumber',
    component: ActivationCodeComponent,
    data: { title: appTitle, animation: 'Authentication2' },
  },
  {
    path: 'register/:phoneNumber',
    component: RegisterComponent,
    data: { title: appTitle, animation: 'Register' },
  },
  {
    path: 'promotion',
    component: PromotionComponent,
    data: { title: appTitle, animation: 'Promotion' },
  },
  {
    path: 'generate/type',
    component: DietTypeComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'DietType' },
  },
  {
    path: 'generate/personal/type',
    component: DietPersonalTypeComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'DietPersonalType' },
  },
  {
    path: 'generate/process',
    component: GenerateComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Generate' },
  },
  {
    path: 'generate/process/:type',
    component: GenerateComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Generate' },
  },
  {
    path: 'generate/overview',
    component: GenerateOverviewComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'GenerateOverview' },
  },
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Main' },
  },
  {
    path: 'main/:tabName',
    component: MainComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Main' },
  },
  {
    path: 'deeplink/:url',
    component: DeeplinkComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle },
  },
  {
    path: 'cheatday/:dietId/:day/:isCheat/:cheatDayCount/:isPredefined',
    component: CheatDayComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'CheatDay' },
  },
  {
    path: 'planoverview',
    component: PlanOverviewComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'PlanOverview' },
  },
  {
    path: 'mealdetail/:dietId/:day/:isPredefined/:cheatDayCount',
    component: MealDetailComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'MealDetail' },
  },
  {
    path: 'persoanl/main/:dietId/:day/:meal',
    component: MainPersonalComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'personals' },
  },
  {
    path: 'persoanl/food/main/:dietId/:day/:meal',
    component: AddPersonalComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'personalFood' },
  },
  {
    path: 'persoanl/food/add/:edit',
    component: CreatePersonalFoodComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'createpersonalFood' },
  },
  {
    path: 'persoanl/package/main/:dietId/:day/:meal',
    component: AddPersonalPackageComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'personalPackage' },
  },
  {
    path: 'persoanl/package/add/:edit',
    component: CreatePersonalPackageComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'createpersonalPackage' },
  },
  {
    path: 'exercise',
    component: ExerciseMainComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'MainExercise' },
  },
  {
    path: 'exercise/new',
    component: ExercisesComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'newExercise' },
  },
  {
    path: 'dailyfoodfact',
    component: DailyFoodFactComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'DailyFoodFact' },
  },
  {
    path: 'changemeal/:dietId/:day/:meal',
    component: ChangeMealComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'ChangeMeal' },
  },
  {
    path: 'addfood/:dietId/:day/:meal',
    component: AddFoodComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'AddFood' },
  },

  {
    path: 'dietdetail',
    component: DietDetailComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'DietDetail' },
  },
  {
    path: 'profilewaterchart',
    component: ProfileWaterChartComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'ProfileWaterChart' },
  },
  {
    path: 'profileweightchart',
    component: ProfileWeightChartComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'ProfileWeightChart' },
  },
  {
    path: 'referral',
    component: ReferralComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Referral' },
  },
  {
    path: 'setting',
    component: SettingComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Setting' },
  },
  {
    path: 'aboutus',
    component: AboutUsComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'AboutUs' },
  },
  {
    path: 'support',
    component: SupportPageComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Support' },
  },
  {
    path: 'message',
    component: MessageInboxComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'MessageInbox' },
  },
  {
    path: 'messagepage/:messageId',
    component: MessagePageComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'MessagePage' },
  },
  {
    path: 'faq/:faqId',
    component: FaqComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'FAQ' },
  },
  {
    path: 'faqanswer/:answerId',
    component: AnswerPageComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'AnswerFAQ' },
  },
  {
    path: 'reportproblem',
    component: ReportProblemComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'ReportProblem' },
  },
  {
    path: 'personalinfo',
    component: PersonalInfoComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'PersonalInfo' },
  },
  {
    path: 'tribunesetting',
    component: TribuneSettingComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'TribuneSetting' },
  },
  {
    path: 'shop/:scenario',
    component: ShopComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Shop' },
  },
  {
    path: 'shop',
    component: ShopComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Shop' },
  },
  {
    path: 'tribune/:username/profile',
    component: BlogProfileComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Profile' },
  },
  {
    path: 'tribune/:username/profile/edit',
    component: BlogSettingComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'ProfileEdit' },
  },
  {
    path: 'tribune/:username/profile/edit',
    component: BlogSettingComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Profile' },
  },
  {
    path: 'tribune/:username/profile/followees',
    component: FollowerFollowingComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'TribuneFolloweese' },
  },
  {
    path: 'tribune/:username/posts/:id',
    component: PostDetailComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'Post' },
  },
  {
    path: 'tribune/search',
    component: BlogSearchComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'TribuneSearch' },
  },
  {
    path: 'tribune/tags',
    component: BlogWithTagComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'TribuneTags' },
  },
  {
    path: 'tribune/suggestion',
    component: BlogSuggestComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'ShTribuneSuggestop' },
  },
  {
    path: 'tribune/activity',
    component: BlogActivityComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'TribuneActivity' },
  },
  {
    path: 'tribune/:username/newpost',
    component: BlogCreatPostComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'TribuneNewPost' },
  },

  {
    path: 'cookingbook/home',
    component: CookingStoryHomeComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },
  {
    path: 'cookingbook/book',
    component: CookingStoryComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },
  {
    path: 'cookingbook/kitchen/:type',
    component: CookingStoryKitchenComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },
  {
    path: 'cookingbook/kitchen/shoppinglist/search',
    component: ShoppinglistSearchComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },
  {
    path: 'cookingbook/kitchen/kitchen/search',
    component: KitchenSearchComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },
  {
    path: 'cookingbook/members',
    component: CookingStoryMembersComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },
  {
    path: 'cookingbook/categorie/:categoryId/:type/:title',
    component: CookingStoryShowMoreComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeCategory' },
  },

  {
    path: 'cookingbook/search',
    component: CookingStorySearchComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeDetail' },
  },
  {
    path: 'cookingbook/favorite',
    component: CookingStoryFavoriteComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeDetail' },
  },
  {
    path: 'cookingbook/:recipeId',
    component: CookingStoryRecipePageComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeDetail' },
  },
  {
    path: 'cookingbook/:recipeId/tutorial',
    component: CookingStoryTutorialComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'RecipeDetail' },
  },
  {
    path: 'bookmarks',
    component: BookmarkedRecipesComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'BookmarkedRecipes' },
  },
  {
    path: 'dietTypeOverview',
    component: DietTypeOverviewComponent,
    canActivate: [AuthGuard],
    data: { title: appTitle, animation: 'DietTypeOverview' },
  },

  { path: '**', redirectTo: 'main' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
